export const MAX_DIGITAL_FULFILLMENT_FILES = 100;
export const MAX_ADDITIONAL_DIGITAL_FILES = MAX_DIGITAL_FULFILLMENT_FILES - 1;

/**
 * Product types whose customers receive a downloadable deliverable file after
 * purchase. The rich per-type label / help / accept map lives in the media
 * wizard (react/.../ProductWizardMedia.jsx); this is the bare type list for
 * logic that only needs "does this product type deliver a file?" — e.g. the
 * publish-pane delivery-file validation. Keep the two in sync.
 */
/**
 * Product types that may carry an ordered set of additional fulfillment files
 * (`metadata.additionalFileIds`). Every file-set gate (helpers, update route,
 * wizard) reads this list; PLAN-MUSIC-PLAYER M1 later adds `song` and `album`.
 */
export const BUNDLE_PRODUCT_TYPES = ['digital', 'ebook'];

export function supportsFileBundle(type) {
    return BUNDLE_PRODUCT_TYPES.includes(type);
}

export const DELIVERABLE_PRODUCT_TYPES = ['digital', 'ebook', 'song', 'album'];
